module.exports = __webpack_public_path__ + "img/close.489d465d.svg";